export const formatDate = (date) => {
  if (date !== null) {
    const dateParts = new Date(date).toLocaleDateString().split("/");
    return (
      (dateParts[0] < 10 ? "0" + dateParts[0] : dateParts[0]) +
      "/" +
      (dateParts[1] < 10 ? "0" + dateParts[1] : dateParts[1]) +
      "/" +
      dateParts[2]
    );
  } else {
    return "";
  }
};

export const formatDateToUrl = (date) => {
  if (date === "") {
    return "-";
  }
  if (date !== null) {
    const dateArray = date.split("/");
    return (
      (parseInt(dateArray[0]) < 10 && !dateArray[0].includes("0") ? "0" + dateArray[0] : dateArray[0]) +
      "-" +
      (parseInt(dateArray[1]) < 10 && !dateArray[0].includes("0") ? "0" + dateArray[1] : dateArray[1]) +
      "-" +
      dateArray[2]
    );
  } else {
    return "";
  }
};

export const formatDateFromTimeStamp = (date) => {
  if (date !== undefined && date !== null) {
    const datePart = date.split("T")[0].split("-");
    return datePart[1] + "/" + datePart[2] + "/" + datePart[0];
  } else {
    return "";
  }
};

export const formatJSDateToTimeStamp = (date) => {
  if (date !== null) {
    return (
      date.getFullYear() +
      "-" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + date.getDate()).slice(-2) +
      " " +
      ("0" + date.getHours()).slice(-2) +
      ":" +
      ("0" + date.getMinutes()).slice(-2) +
      ":" +
      ("0" + date.getSeconds()).slice(-2)
    );
  } else {
    return "";
  }
};

export const formatDateTimeFromTimeStamp = (date) => {
  if (date !== null) {
    const datePart = date.split("T")[0].split("-");
    const time = date.split("T")[1].split(".")[0];
    return datePart[1] + "/" + datePart[2] + "/" + datePart[0] + " " + time;
  } else {
    return "";
  }
};

export const formatDateTimeFromJavaDate = (date) => {
  if (date !== null) {
    const datePart = date.split(" ")[0].split("-");
    const time = date.split(" ")[1].split(".")[0];
    return datePart[1] + "/" + datePart[2] + "/" + datePart[0] + " " + time;
  } else {
    return "";
  }
};

export const formatJsDateToCome = (date) => {
  if (date !== null) {
    return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
  } else {
    return "";
  }
};

export const formatJsDate = (date) => {
  if (date !== null) {
    return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
  } else {
    return "";
  }
};

export const formatDateToHTMLInput = (date) => {
  if (date !== null) {
    const dateParts = new Date(date).toLocaleDateString().split("/");
    return (
      dateParts[2] +
      "-" +
      (dateParts[0] < 10 ? "0" + dateParts[0] : dateParts[0]) +
      "-" +
      (dateParts[1] < 10 ? "0" + dateParts[1] : dateParts[1])
    );
  } else {
    return "";
  }
};

export const formatNumberToDecimal = (number, decimalNumber) => {
  if (number === null || number === undefined) {
    return "";
  } else {
    return Number.parseFloat(number).toFixed(decimalNumber);
  }
};

export const numberWithCommas = (number) => {
  if (number === null || number === undefined) {
    return 0;
  } else {
    if (typeof number === "string") {
      if (number.includes(".")) return parseFloat(number).toLocaleString();
      else return parseInt(number).toLocaleString();
    } else {
      return number.toLocaleString();
    }
  }
};

export const formatMoney = (val, decimal) => {
  if (val == null || isNaN(val) || val === "") return parseFloat(0).toFixed(decimal !== undefined ? decimal : 2);
  // Formatting money with thousands separators (1000 -> 1,000)
  return "$ " + numberWithCommas(parseFloat(val).toFixed(decimal !== undefined ? decimal : 2));
};

export const formatPhoneNumber = (val) => {
  if (val === undefined || val == null || val === "") return "-";
  else return val.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
};

export const formatTableDateForInput = (date) => {
  if (date === undefined || date === null) {
    return "";
  } else {
    const [datePart, timePart] = date.split(" ");
    const [month, day, year] = datePart.split("/");
    const [hours, minutes, seconds] = timePart.split(":");
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }
};
